import React from 'react';

function HomepageEditor() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Homepage Editor</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">Edit your homepage content here.</p>
      </div>
    </div>
  );
}

export default HomepageEditor;